import { render, staticRenderFns } from "./SliderRangerValue.vue?vue&type=template&id=4c61df40&"
import script from "./SliderRangerValue.vue?vue&type=script&lang=js&"
export * from "./SliderRangerValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports